import React from "react";
import styled from "@emotion/styled";

interface VideoLightboxProps {
    videoUrl: string;
    onRequestClose: () => void;
}

const VideoLightbox: React.FC<VideoLightboxProps> = ({
    videoUrl,
    onRequestClose,
}) => {
    const getVideoId = (url: string): string => {
        const videoId = url.split("v=")[1];
        const ampersandPosition = videoId.indexOf("&");
        if (ampersandPosition !== -1) {
            return videoId.substring(0, ampersandPosition);
        }
        return videoId;
    };

    const videoId = getVideoId(videoUrl);
    const embedUrl = `https://www.youtube.com/embed/${videoId}?autoplay=1`;

    return (
        <ModalOverlay onClick={onRequestClose}>
            <ModalContent onClick={(e) => e.stopPropagation()}>
                <iframe
                    title="YouTube video player"
                    src={embedUrl}
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                    width="560"
                    height="315"
                ></iframe>
            </ModalContent>
        </ModalOverlay>
    );
};

export default VideoLightbox;

const ModalOverlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 50;
`;

const ModalContent = styled.div`
    background-color: #fff;
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
`;
